import { ReactPixel, pixelInitialised } from '../services/reactPixel';

import { CHANGE_STEP, CART_PAID } from "../actions/actionTypes";

const reactPixelMiddleware = store => next => action => {

    next(action);

    if (pixelInitialised) {
        let pixelState = store.getState();
        const stage = pixelState.common.stepIndex + 1;
        const stageDesc = {
            1: "InitiateCheckout",
            2: "CompleteRegistration",
            3: "AddPaymentInfo",
        }

        switch (action.type) {
            case CART_PAID:
                ReactPixel.fbq('track', 'Purchase', {
                    value: (pixelState.cart.totals.total / 100).toFixed(2),
                    currency: pixelState.personal.currency_code,
                });
                break;
            case CHANGE_STEP:
                ReactPixel.fbq('track', stageDesc[stage]);
                break;
            default:
        }
    }
};

export default reactPixelMiddleware;